// Re-export the campaign-focused homepage
import CampaignHomePage from "./CampaignHomePage";

const Index = () => {
  return <CampaignHomePage />;
};

export default Index;
